import { BRAND_POWERED_BY_STRIPE_URL } from "@/lib/brandConfig";

type PoweredByStripeBadgeProps = {
  /** Extra classes on the outer wrapper */
  className?: string;
  /** Image height classes (default h-5) */
  imageClassName?: string;
};

/**
 * Trust mark for non-AR (Stripe) checkouts: /vip/:slug intl + /sorprendeme.
 * Asset: brandConfig `BRAND_POWERED_BY_STRIPE_URL`.
 */
export default function PoweredByStripeBadge({
  className = "",
  imageClassName = "h-5 w-auto",
}: PoweredByStripeBadgeProps) {
  return (
    <div
      className={`flex items-center justify-center ${className}`.trim()}
      role="img"
      aria-label="Powered by Stripe"
    >
      <img
        src={BRAND_POWERED_BY_STRIPE_URL}
        alt="Powered by Stripe"
        className={`pointer-events-none select-none object-contain opacity-90 ${imageClassName}`}
        loading="lazy"
        decoding="async"
        draggable={false}
      />
    </div>
  );
}
